import React from 'react';
import Tooltip from '@amzn/meridian/tooltip';

interface HoverZoomImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  zoomWidth?: number;
  zoomHeight?: number;
}

const HoverZoomImage: React.FC<HoverZoomImageProps> = ({
  src,
  alt,
  width = 40,
  height = 40,
  zoomWidth = 200,
  zoomHeight = 200,
}) => (
  <Tooltip
    position="end"
    title={<img src={src} alt={alt} style={{ width: zoomWidth, height: zoomHeight, objectFit: 'contain' }} />}
  >
    <img src={src} alt={alt} style={{ width, height, objectFit: 'contain', cursor: 'pointer' }} />
  </Tooltip>
);

export default HoverZoomImage;
